export class LegListPriceOverride {
  constructor(
    public standartPrice: boolean = false,
    public increasedPrice: boolean = true,
    public decreasedPrice: boolean = true
  ) {}
}
